var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1490_443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47439 2.73683H4.73755C4.7957 2.73683 4.84281 2.68968 4.84281 2.63158V0.105253C4.84281 0.0471061 4.7957 0 4.73755 0H3.47439C3.41625 0 3.36914 0.0471464 3.36914 0.105253V2.63158C3.36914 2.68972 3.41625 2.73683 3.47439 2.73683Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8215 1.89453H13.2636V2.5682C13.2636 2.96822 12.9689 3.3682 12.5689 3.3682H11.3268C10.8981 3.33782 10.5572 2.99683 10.5268 2.5682V1.89453H5.47413V2.5682C5.44375 2.99683 5.10276 3.33782 4.67413 3.3682H3.432C3.03198 3.3682 2.73726 2.96818 2.73726 2.5682V1.89453H1.17937C0.641138 1.90602 0.210817 2.34569 0.210938 2.88404V5.47351H15.7899V2.88404C15.79 2.34569 15.3597 1.90602 14.8215 1.89453Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2635 2.73683H12.5266C12.5848 2.73683 12.6319 2.68968 12.6319 2.63158V0.105253C12.6319 0.0471061 12.5847 0 12.5266 0H11.2635C11.2053 0 11.1582 0.0471464 11.1582 0.105253V2.63158C11.1582 2.68972 11.2053 2.73683 11.2635 2.73683Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42197 11.7465L6.12724 13.4517L7.64302 12.6517L7.79038 12.6096L7.93775 12.6517L9.45352 13.4517L9.1588 11.7465C9.14755 11.6475 9.17806 11.5483 9.24302 11.4728L10.4851 10.2938L8.77989 10.0412C8.6802 10.0253 8.59417 9.96273 8.54831 9.87279L7.79042 8.33594L7.03253 9.87279C6.98668 9.96273 6.90065 10.0253 6.80095 10.0412L5.0957 10.2938L6.33783 11.4728C6.40271 11.5483 6.43321 11.6475 6.42197 11.7465Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.210938 15.0528C0.222382 15.5794 0.652623 16.0003 1.17937 16.0002H14.8215C15.3482 16.0003 15.7784 15.5794 15.7899 15.0528V6.10547H0.210938V15.0528ZM4.12675 9.97917C4.16036 9.86417 4.26021 9.78095 4.37936 9.76866L6.54778 9.43183L7.51621 7.47392C7.60321 7.32277 7.79631 7.27079 7.94746 7.35779C7.99574 7.38559 8.03579 7.42565 8.06359 7.47392L9.03203 9.43183L11.2004 9.76866C11.3196 9.78095 11.4195 9.86421 11.4531 9.97917C11.4913 10.0918 11.4581 10.2163 11.3688 10.295L9.81095 11.8107L10.1899 13.9792C10.2045 14.0931 10.1561 14.2059 10.0636 14.2739C10.0082 14.3136 9.9422 14.3356 9.8741 14.337C9.82143 14.342 9.7688 14.327 9.72673 14.2949L7.7899 13.2844L5.85307 14.2949C5.7475 14.3592 5.61299 14.3509 5.51624 14.2739C5.42368 14.2059 5.37532 14.093 5.38991 13.9792L5.76885 11.8107L4.21097 10.295C4.12175 10.2163 4.08855 10.0918 4.12675 9.97917Z",
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1490_443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.e9c3996ebfb43f57704d4cd14a52f7b5.svg";
export { ForwardRef as ReactComponent };